import { useMemo } from "react";

import { type IOAuthStateParamState } from "commonComponents/auth/AuthStoreDiscovery.types";

/**
 * Custom hook to create OAuth state for authentication flows.
 * Generates a unique state identifier and preserves the last requested page.
 *
 * @param lastPageRequested - The page to redirect to after authentication
 * @returns OAuth state object or null if no redirect page is provided
 */
export const useOAuthState = (lastPageRequested?: string): IOAuthStateParamState | null => {
    return useMemo(() => {
        if (lastPageRequested) {
            return {
                stateIdentifier: crypto.randomUUID().toUpperCase(),
                lastPageRequested: lastPageRequested,
            };
        }
        return null;
    }, [lastPageRequested]);
};
